module.exports = __webpack_public_path__ + "static/media/VectorRight.e012e633.svg";